export function formatNumberForDisplay(value) {
  if (value == null)
    return null

  const locale = document.documentElement.lang || "fr-FR"
  return value.toLocaleString(locale, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false
  })
}

export function parseUserInput(value) {
  const num = parseFloat((value || "").toString().replace(",", "."))
  return isNaN(num) ? null : Math.abs(num)
}

